export type EditionType = 'None' | 'Plan' | 'GrpSchemaSelected' | 'GrpSchemaNotSelected' | 'GrpOrderSelected' | 'GrpOrderHorsPlan';

export default class PrintBoarFilterViewModel {
    mountingPlanId: number = 0;
    groupMountingId: number = 0;
    buildingId: number = 0;
    sectorids: number[] = [];
    typeEdition: EditionType = 'GrpSchemaSelected'; // Type d'édition des étiquettes
    nbrLabelByBoar: number = 1; // Nombre d'étiquettes par verrat
    nbrEmptyLabelAtStart: number = 1; // Première position à imprimer

    constructor(
        mountingPlanId: number = 0,
        groupMountingId: number = 0,
        buildingId: number = 0,
        sectorids: number[] = [],
        typeEdition: EditionType = 'GrpSchemaSelected',
        nbrLabelByBoar: number = 1,
        nbrEmptyLabelAtStart: number = 1
    ) {
        this.mountingPlanId = mountingPlanId;
        this.groupMountingId = groupMountingId;
        this.buildingId = buildingId;
        this.sectorids = sectorids;
        this.typeEdition = typeEdition;
        this.nbrLabelByBoar = nbrLabelByBoar;
        this.nbrEmptyLabelAtStart = nbrEmptyLabelAtStart;
    }
}
